(function () {
  "use strict";

  var BLEND_HANDLE = "ottawa-lumber-bins-the-blend";
  var TRIGGER_TAG = "cutting-board";
  var blendVariantId = null;
  var drawerShown = false;

  function getDrawer() { return document.getElementById("olb-upsell-drawer"); }
  function getBackdrop() { return document.getElementById("olb-upsell-backdrop"); }

  function showDrawer() {
    if (drawerShown) return;
    drawerShown = true;
    var drawer = getDrawer(), backdrop = getBackdrop();
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "false");
    drawer.classList.add("olb-is-open");
    backdrop.style.display = "block";
    backdrop.offsetHeight;
    backdrop.classList.add("olb-is-open");
  }

  function hideDrawer() {
    drawerShown = false;
    var drawer = getDrawer(), backdrop = getBackdrop();
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "true");
    drawer.classList.remove("olb-is-open");
    backdrop.classList.remove("olb-is-open");
    setTimeout(function () { backdrop.style.display = "none"; }, 300);
    if (window._olbGoToCartAfterDrawer) {
      window._olbGoToCartAfterDrawer = false;
      setTimeout(function() { window.location.href = '/cart'; }, 300);
    }
  }

  function addBlendToCart() {
    if (!blendVariantId) return;
    var btn = document.getElementById("olb-upsell-add");
    if (!btn) return;
    var originalText = btn.textContent;
    btn.textContent = "Adding...";
    btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: blendVariantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = "Added ✓";
        setTimeout(hideDrawer, 900);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }

  function isBlendInCart(items) {
    return items && items.some(function (item) { return item.handle === BLEND_HANDLE; });
  }

  function fetchBlendVariant() {
    return fetch("/products/" + BLEND_HANDLE + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return null;
        blendVariantId = product.variants[0].id;
        return blendVariantId;
      })
      .catch(function () { return null; });
  }

  function hasTriggerTag(handle) {
    return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        return !!(product && product.tags && product.tags.indexOf(TRIGGER_TAG) !== -1);
      })
      .catch(function () { return false; });
  }

  function subscribeToCartUpdates() {
    if (typeof subscribe === "undefined" || typeof PUB_SUB_EVENTS === "undefined") {
      setTimeout(subscribeToCartUpdates, 150);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source === "upsell-blend" || drawerShown) return;

      var addedHandle = event.cartData && event.cartData.handle;
      if (!addedHandle || addedHandle === BLEND_HANDLE) return;

      hasTriggerTag(addedHandle).then(function (hasTag) {
        if (!hasTag) return;
        fetch("/cart.js")
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (isBlendInCart(cart.items)) return;
            return fetchBlendVariant().then(function (id) {
              if (id) setTimeout(showDrawer, 450);
            });
          })
          .catch(function () {});
      });
    });
  }

  function wireUpButtons() {
    var closeBtn = document.getElementById("olb-upsell-close");
    var skipBtn = document.getElementById("olb-upsell-skip");
    var addBtn = document.getElementById("olb-upsell-add");
    var backdrop = getBackdrop();
    if (closeBtn) closeBtn.addEventListener("click", hideDrawer);
    if (skipBtn) skipBtn.addEventListener("click", hideDrawer);
    if (addBtn) addBtn.addEventListener("click", addBlendToCart);
    if (backdrop) backdrop.addEventListener("click", hideDrawer);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") hideDrawer(); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      subscribeToCartUpdates();
      wireUpButtons();
    });
  } else {
    subscribeToCartUpdates();
    wireUpButtons();
  }
})();
